$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$('nav ul.right-icons li a, a.loginact').click( function(e){
    if($(this).data('sec')=='appointment'){
        e.preventDefault();
        window.location.href = '/make-an-appointment';
        return true;
    }

    if( $(this).attr('data-validate') == 1 ){
      if( $(this).attr('data-logined') == 0 ){
        e.preventDefault();

        _loginredirect = '';
        $('body').addClass('login-overlay');
        $('.login-overlay-div .inner-box' ).hide();
        $('.login-overlay-div .err-msg').hide();
        $('.login-overlay-div .inner-box.'+$(this).attr('data-sec')+'-inner' ).show();

        if( $(this).attr('data-redirect') )_loginredirect = $(this).attr('data-redirect');

      }
    }
});

function validateEmail(sEmail) {
    var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
    if (filter.test(sEmail)) return true;
    else return false;
  }

$('#btnAppointment').click( function(e){
    e.preventDefault();

    if( $(this).hasClass('dis') ) return;

    $(this).parent().find('.has-error').removeClass('has-error');
    $('.login-inner .err-msg').hide();

    var isOK = true;
    var obj = $('input[name="txtAPEmailAddress"]');
    if( !validateEmail(obj.val()) ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('select[name="txtAPBoutique"]');
    if( obj.val() == "" ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAPName"]');
    if( obj.val().length < 3 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAPContactNo"]');
    if( obj.val().length < 10 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAPAddressPostcode"]');
    if( obj.val().length < 5 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAPAppointmentDate"]');
    if( obj.val().length < 10 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    var str = "";
    $('input[name="chkAPInterest[]"]:checked').each(function() {
      str += this.value + ",";
   });

   if( str.length != 0 ) str = str.substr(0, str.length - 1);


    if( !isOK ) return;

    $(this).addClass('dis');

    $.ajax(
      {
        method: "POST", url: "/api/appointment",
        data :{
          boutique: $('select[name="txtAPBoutique"]').val(),
          name: $('input[name="txtAPName"]').val(),
          email: $('input[name="txtAPEmailAddress"]').val(),
          contactno: $('input[name="txtAPContactNo"]').val(),
          postcode: $('input[name="txtAPAddressPostcode"]').val(),
          date: $('input[name="txtAPAppointmentDate"]').val(),
          message: $('textarea[name="txtAPMessage"]').val(),
          interest: str,
        },
        success: function (response) {
          $('.appointment-inner .greetings').hide();
         $('.appointment-inner .formarea').html('DeGem customer care will be in touch with you soon. <br><br>Thank you.');
        }
      });



  });

  $('#btnLogin').click( function(e){
    e.preventDefault();

    if( $(this).hasClass('dis') ) return;

    $(this).parent().find('.has-error').removeClass('has-error');
    $('.login-inner .err-msg').hide();

    var isOK = true;
    var obj = $('input[name="txtLoginEmail"]');
    if( !validateEmail(obj.val()) ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtLoginPassword"]');
    if( obj.val() == "" ) {
      isOK = false;
      obj.addClass('has-error');
    }

    if( !isOK ) return;

    $(this).addClass('dis');

    $.ajax(
      {
        method: "POST", url: "/api/login",
        data :{
          email: $('input[name="txtLoginEmail"]').val(),
          password: $('input[name="txtLoginPassword"]').val()
        },
        success: function (response) {
          if( response.status == 1 ) window.location.reload();
          else {
            $('.login-inner .err-msg').show();
            $('#btnLogin').removeClass('dis');
          }
        }
      });
  });

  $('.login-overlay-div a.closeButton, .info-overlay-div a.closeButton, .address-overlay-div a.closeButton').click( function(e){
    $('body').removeClass('info-overlay login-overlay address-overlay');
  });
